/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AvailableSectionDto } from '../models';
// @ts-ignore
import type { DetachPoolFromStage409ResponseDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { QuestionPoolUploadResultDto } from '../models';
// @ts-ignore
import type { SetQuestionPoolActiveRequestDto } from '../models';
// @ts-ignore
import type { TestQuestionPoolDetailDto } from '../models';
// @ts-ignore
import type { TestQuestionPoolListResponseDto } from '../models';
// @ts-ignore
import type { TestQuestionPoolSummaryDto } from '../models';
// @ts-ignore
import type { TestQuestionSearchResultDto } from '../models';
// @ts-ignore
import type { TestQuestionTypeDto } from '../models';
/**
 * TestQuestionPoolApi - axios parameter creator
 * @export
 */
export const TestQuestionPoolApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Attach a question pool to a TEST stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachPoolToStage: async (certificationId: number, stageId: number, poolId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('attachPoolToStage', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('attachPoolToStage', 'stageId', stageId)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('attachPoolToStage', 'poolId', poolId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/question-pools/{poolId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the association between the pool and stage. Does not delete the pool or its questions. Returns 409 Conflict if the TEST stage has at least one active term (status NEW or IN_PROGRESS) — detaching the pool while terms are running would break test execution for participants. 
         * @summary Detach a question pool from a TEST stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachPoolFromStage: async (certificationId: number, stageId: number, poolId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('detachPoolFromStage', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('detachPoolFromStage', 'stageId', stageId)
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('detachPoolFromStage', 'poolId', poolId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/question-pools/{poolId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns distinct section names from all question pools attached to the given stage. Use this to populate section options when configuring the test stage. 
         * @summary Get available sections for a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSectionsForStage: async (certificationId: number, stageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getAvailableSectionsForStage', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getAvailableSectionsForStage', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/available-sections`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get question pool detail with all questions
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionPoolDetail: async (poolId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('getQuestionPoolDetail', 'poolId', poolId)
            const localVarPath = `/api/v2/test-question-pools/{poolId}`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get question pools attached to a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStageQuestionPools: async (certificationId: number, stageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getStageQuestionPools', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getStageQuestionPools', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/question-pools`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of all question pools. Supports name search and sorting by name or creation date. 
         * @summary List all question pools with pagination and filters
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by pool name (partial match)
         * @param {ListQuestionPoolsSortByEnum} [sortBy] Field to sort by
         * @param {ListQuestionPoolsSortDirectionEnum} [sortDirection] Sort direction
         * @param {ListQuestionPoolsStageTypeEnum} [stageType] Filter by stage type (TEST or EXAM)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuestionPools: async (page?: number, pageSize?: number, search?: string, sortBy?: ListQuestionPoolsSortByEnum, sortDirection?: ListQuestionPoolsSortDirectionEnum, stageType?: ListQuestionPoolsStageTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/test-question-pools`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (stageType !== undefined) {
                localVarQueryParameter['stageType'] = stageType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of questions from the specified pool. Supports full-text search (PostgreSQL tsvector) across question content, answers, section, and explanation. 
         * @summary Search questions in a pool with pagination and filters
         * @param {number} poolId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {TestQuestionTypeDto} [questionType] Filter by question type
         * @param {string} [section] Filter by section name (partial match)
         * @param {string} [search] Full-text search across question content, answers, section, and explanation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchQuestionsByPool: async (poolId: number, page?: number, pageSize?: number, questionType?: TestQuestionTypeDto, section?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('searchQuestionsByPool', 'poolId', poolId)
            const localVarPath = `/api/v2/test-question-pools/{poolId}/questions`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (questionType !== undefined) {
                localVarQueryParameter['questionType'] = questionType;
            }

            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of questions from all pools attached to the specified stage. Supports full-text search (PostgreSQL tsvector) across question content, answers, section, and explanation. 
         * @summary Search questions across all pools attached to a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {TestQuestionTypeDto} [questionType] Filter by question type
         * @param {string} [section] Filter by section name (partial match)
         * @param {string} [search] Full-text search across question content, answers, section, and explanation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchQuestionsByStage: async (certificationId: number, stageId: number, page?: number, pageSize?: number, questionType?: TestQuestionTypeDto, section?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('searchQuestionsByStage', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('searchQuestionsByStage', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/questions`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (questionType !== undefined) {
                localVarQueryParameter['questionType'] = questionType;
            }

            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggles whether the pool is \"active\". Inactive pools are excluded from question drawing for newly generated exams; questions already drawn into existing exams remain intact. 
         * @summary Set test question pool active flag
         * @param {number} poolId 
         * @param {SetQuestionPoolActiveRequestDto} setQuestionPoolActiveRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTestQuestionPoolActive: async (poolId: number, setQuestionPoolActiveRequestDto: SetQuestionPoolActiveRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('setTestQuestionPoolActive', 'poolId', poolId)
            // verify required parameter 'setQuestionPoolActiveRequestDto' is not null or undefined
            assertParamExists('setTestQuestionPoolActive', 'setQuestionPoolActiveRequestDto', setQuestionPoolActiveRequestDto)
            const localVarPath = `/api/v2/test-question-pools/{poolId}/active`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setQuestionPoolActiveRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new question pool and uploads questions from the Excel file. If stageId is provided, the pool is automatically attached to the stage. stageType determines the Excel format: TEST (11 columns with answers A-D) or EXAM (3 columns: nr, question, answerKey). 
         * @summary Upload new question pool from Excel file
         * @param {File} file Excel file (.xlsx) with questions
         * @param {number} [stageId] Optional stage ID to attach the pool to
         * @param {UploadNewQuestionPoolStageTypeEnum} [stageType] Stage type for the pool (TEST or EXAM). Defaults to TEST.
         * @param {string} [name] Pool name (defaults to sheet name if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNewQuestionPool: async (file: File, stageId?: number, stageType?: UploadNewQuestionPoolStageTypeEnum, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadNewQuestionPool', 'file', file)
            const localVarPath = `/api/v2/test-question-pools/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (stageId !== undefined) {
                localVarQueryParameter['stageId'] = stageId;
            }

            if (stageType !== undefined) {
                localVarQueryParameter['stageType'] = stageType;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds questions from the Excel file to an existing pool. Questions are appended, not replaced. 
         * @summary Upload questions to an existing pool (append)
         * @param {number} poolId 
         * @param {File} file Excel file (.xlsx) with questions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadToExistingPool: async (poolId: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolId' is not null or undefined
            assertParamExists('uploadToExistingPool', 'poolId', poolId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadToExistingPool', 'file', file)
            const localVarPath = `/api/v2/test-question-pools/{poolId}/upload`
                .replace(`{${"poolId"}}`, encodeURIComponent(String(poolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestQuestionPoolApi - functional programming interface
 * @export
 */
export const TestQuestionPoolApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestQuestionPoolApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Attach a question pool to a TEST stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachPoolToStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachPoolToStage(certificationId, stageId, poolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestQuestionPoolApi.attachPoolToStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the association between the pool and stage. Does not delete the pool or its questions. Returns 409 Conflict if the TEST stage has at least one active term (status NEW or IN_PROGRESS) — detaching the pool while terms are running would break test execution for participants. 
         * @summary Detach a question pool from a TEST stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detachPoolFromStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detachPoolFromStage(certificationId, stageId, poolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestQuestionPoolApi.detachPoolFromStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns distinct section names from all question pools attached to the given stage. Use this to populate section options when configuring the test stage. 
         * @summary Get available sections for a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableSectionsForStage(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvailableSectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableSectionsForStage(certificationId, stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestQuestionPoolApi.getAvailableSectionsForStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get question pool detail with all questions
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionPoolDetail(poolId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestQuestionPoolDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionPoolDetail(poolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestQuestionPoolApi.getQuestionPoolDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get question pools attached to a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStageQuestionPools(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestQuestionPoolSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStageQuestionPools(certificationId, stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestQuestionPoolApi.getStageQuestionPools']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of all question pools. Supports name search and sorting by name or creation date. 
         * @summary List all question pools with pagination and filters
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by pool name (partial match)
         * @param {ListQuestionPoolsSortByEnum} [sortBy] Field to sort by
         * @param {ListQuestionPoolsSortDirectionEnum} [sortDirection] Sort direction
         * @param {ListQuestionPoolsStageTypeEnum} [stageType] Filter by stage type (TEST or EXAM)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listQuestionPools(page?: number, pageSize?: number, search?: string, sortBy?: ListQuestionPoolsSortByEnum, sortDirection?: ListQuestionPoolsSortDirectionEnum, stageType?: ListQuestionPoolsStageTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestQuestionPoolListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listQuestionPools(page, pageSize, search, sortBy, sortDirection, stageType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestQuestionPoolApi.listQuestionPools']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of questions from the specified pool. Supports full-text search (PostgreSQL tsvector) across question content, answers, section, and explanation. 
         * @summary Search questions in a pool with pagination and filters
         * @param {number} poolId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {TestQuestionTypeDto} [questionType] Filter by question type
         * @param {string} [section] Filter by section name (partial match)
         * @param {string} [search] Full-text search across question content, answers, section, and explanation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchQuestionsByPool(poolId: number, page?: number, pageSize?: number, questionType?: TestQuestionTypeDto, section?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestQuestionSearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchQuestionsByPool(poolId, page, pageSize, questionType, section, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestQuestionPoolApi.searchQuestionsByPool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of questions from all pools attached to the specified stage. Supports full-text search (PostgreSQL tsvector) across question content, answers, section, and explanation. 
         * @summary Search questions across all pools attached to a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {TestQuestionTypeDto} [questionType] Filter by question type
         * @param {string} [section] Filter by section name (partial match)
         * @param {string} [search] Full-text search across question content, answers, section, and explanation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchQuestionsByStage(certificationId: number, stageId: number, page?: number, pageSize?: number, questionType?: TestQuestionTypeDto, section?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestQuestionSearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchQuestionsByStage(certificationId, stageId, page, pageSize, questionType, section, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestQuestionPoolApi.searchQuestionsByStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggles whether the pool is \"active\". Inactive pools are excluded from question drawing for newly generated exams; questions already drawn into existing exams remain intact. 
         * @summary Set test question pool active flag
         * @param {number} poolId 
         * @param {SetQuestionPoolActiveRequestDto} setQuestionPoolActiveRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setTestQuestionPoolActive(poolId: number, setQuestionPoolActiveRequestDto: SetQuestionPoolActiveRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setTestQuestionPoolActive(poolId, setQuestionPoolActiveRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestQuestionPoolApi.setTestQuestionPoolActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new question pool and uploads questions from the Excel file. If stageId is provided, the pool is automatically attached to the stage. stageType determines the Excel format: TEST (11 columns with answers A-D) or EXAM (3 columns: nr, question, answerKey). 
         * @summary Upload new question pool from Excel file
         * @param {File} file Excel file (.xlsx) with questions
         * @param {number} [stageId] Optional stage ID to attach the pool to
         * @param {UploadNewQuestionPoolStageTypeEnum} [stageType] Stage type for the pool (TEST or EXAM). Defaults to TEST.
         * @param {string} [name] Pool name (defaults to sheet name if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadNewQuestionPool(file: File, stageId?: number, stageType?: UploadNewQuestionPoolStageTypeEnum, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionPoolUploadResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadNewQuestionPool(file, stageId, stageType, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestQuestionPoolApi.uploadNewQuestionPool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds questions from the Excel file to an existing pool. Questions are appended, not replaced. 
         * @summary Upload questions to an existing pool (append)
         * @param {number} poolId 
         * @param {File} file Excel file (.xlsx) with questions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadToExistingPool(poolId: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionPoolUploadResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadToExistingPool(poolId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestQuestionPoolApi.uploadToExistingPool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestQuestionPoolApi - factory interface
 * @export
 */
export const TestQuestionPoolApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestQuestionPoolApiFp(configuration)
    return {
        /**
         * 
         * @summary Attach a question pool to a TEST stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachPoolToStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.attachPoolToStage(certificationId, stageId, poolId, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the association between the pool and stage. Does not delete the pool or its questions. Returns 409 Conflict if the TEST stage has at least one active term (status NEW or IN_PROGRESS) — detaching the pool while terms are running would break test execution for participants. 
         * @summary Detach a question pool from a TEST stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachPoolFromStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.detachPoolFromStage(certificationId, stageId, poolId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns distinct section names from all question pools attached to the given stage. Use this to populate section options when configuring the test stage. 
         * @summary Get available sections for a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSectionsForStage(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AvailableSectionDto>> {
            return localVarFp.getAvailableSectionsForStage(certificationId, stageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get question pool detail with all questions
         * @param {number} poolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionPoolDetail(poolId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestQuestionPoolDetailDto> {
            return localVarFp.getQuestionPoolDetail(poolId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get question pools attached to a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStageQuestionPools(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TestQuestionPoolSummaryDto>> {
            return localVarFp.getStageQuestionPools(certificationId, stageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of all question pools. Supports name search and sorting by name or creation date. 
         * @summary List all question pools with pagination and filters
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by pool name (partial match)
         * @param {ListQuestionPoolsSortByEnum} [sortBy] Field to sort by
         * @param {ListQuestionPoolsSortDirectionEnum} [sortDirection] Sort direction
         * @param {ListQuestionPoolsStageTypeEnum} [stageType] Filter by stage type (TEST or EXAM)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuestionPools(page?: number, pageSize?: number, search?: string, sortBy?: ListQuestionPoolsSortByEnum, sortDirection?: ListQuestionPoolsSortDirectionEnum, stageType?: ListQuestionPoolsStageTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<TestQuestionPoolListResponseDto> {
            return localVarFp.listQuestionPools(page, pageSize, search, sortBy, sortDirection, stageType, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of questions from the specified pool. Supports full-text search (PostgreSQL tsvector) across question content, answers, section, and explanation. 
         * @summary Search questions in a pool with pagination and filters
         * @param {number} poolId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {TestQuestionTypeDto} [questionType] Filter by question type
         * @param {string} [section] Filter by section name (partial match)
         * @param {string} [search] Full-text search across question content, answers, section, and explanation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchQuestionsByPool(poolId: number, page?: number, pageSize?: number, questionType?: TestQuestionTypeDto, section?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestQuestionSearchResultDto> {
            return localVarFp.searchQuestionsByPool(poolId, page, pageSize, questionType, section, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of questions from all pools attached to the specified stage. Supports full-text search (PostgreSQL tsvector) across question content, answers, section, and explanation. 
         * @summary Search questions across all pools attached to a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {TestQuestionTypeDto} [questionType] Filter by question type
         * @param {string} [section] Filter by section name (partial match)
         * @param {string} [search] Full-text search across question content, answers, section, and explanation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchQuestionsByStage(certificationId: number, stageId: number, page?: number, pageSize?: number, questionType?: TestQuestionTypeDto, section?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestQuestionSearchResultDto> {
            return localVarFp.searchQuestionsByStage(certificationId, stageId, page, pageSize, questionType, section, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggles whether the pool is \"active\". Inactive pools are excluded from question drawing for newly generated exams; questions already drawn into existing exams remain intact. 
         * @summary Set test question pool active flag
         * @param {number} poolId 
         * @param {SetQuestionPoolActiveRequestDto} setQuestionPoolActiveRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTestQuestionPoolActive(poolId: number, setQuestionPoolActiveRequestDto: SetQuestionPoolActiveRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setTestQuestionPoolActive(poolId, setQuestionPoolActiveRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new question pool and uploads questions from the Excel file. If stageId is provided, the pool is automatically attached to the stage. stageType determines the Excel format: TEST (11 columns with answers A-D) or EXAM (3 columns: nr, question, answerKey). 
         * @summary Upload new question pool from Excel file
         * @param {File} file Excel file (.xlsx) with questions
         * @param {number} [stageId] Optional stage ID to attach the pool to
         * @param {UploadNewQuestionPoolStageTypeEnum} [stageType] Stage type for the pool (TEST or EXAM). Defaults to TEST.
         * @param {string} [name] Pool name (defaults to sheet name if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNewQuestionPool(file: File, stageId?: number, stageType?: UploadNewQuestionPoolStageTypeEnum, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionPoolUploadResultDto> {
            return localVarFp.uploadNewQuestionPool(file, stageId, stageType, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds questions from the Excel file to an existing pool. Questions are appended, not replaced. 
         * @summary Upload questions to an existing pool (append)
         * @param {number} poolId 
         * @param {File} file Excel file (.xlsx) with questions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadToExistingPool(poolId: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<QuestionPoolUploadResultDto> {
            return localVarFp.uploadToExistingPool(poolId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestQuestionPoolApi - interface
 * @export
 * @interface TestQuestionPoolApi
 */
export interface TestQuestionPoolApiInterface {
    /**
     * 
     * @summary Attach a question pool to a TEST stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} poolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApiInterface
     */
    attachPoolToStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Removes the association between the pool and stage. Does not delete the pool or its questions. Returns 409 Conflict if the TEST stage has at least one active term (status NEW or IN_PROGRESS) — detaching the pool while terms are running would break test execution for participants. 
     * @summary Detach a question pool from a TEST stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} poolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApiInterface
     */
    detachPoolFromStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Returns distinct section names from all question pools attached to the given stage. Use this to populate section options when configuring the test stage. 
     * @summary Get available sections for a stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApiInterface
     */
    getAvailableSectionsForStage(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AvailableSectionDto>>;

    /**
     * 
     * @summary Get question pool detail with all questions
     * @param {number} poolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApiInterface
     */
    getQuestionPoolDetail(poolId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestQuestionPoolDetailDto>;

    /**
     * 
     * @summary Get question pools attached to a stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApiInterface
     */
    getStageQuestionPools(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TestQuestionPoolSummaryDto>>;

    /**
     * Returns paginated list of all question pools. Supports name search and sorting by name or creation date. 
     * @summary List all question pools with pagination and filters
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by pool name (partial match)
     * @param {ListQuestionPoolsSortByEnum} [sortBy] Field to sort by
     * @param {ListQuestionPoolsSortDirectionEnum} [sortDirection] Sort direction
     * @param {ListQuestionPoolsStageTypeEnum} [stageType] Filter by stage type (TEST or EXAM)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApiInterface
     */
    listQuestionPools(page?: number, pageSize?: number, search?: string, sortBy?: ListQuestionPoolsSortByEnum, sortDirection?: ListQuestionPoolsSortDirectionEnum, stageType?: ListQuestionPoolsStageTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<TestQuestionPoolListResponseDto>;

    /**
     * Returns paginated list of questions from the specified pool. Supports full-text search (PostgreSQL tsvector) across question content, answers, section, and explanation. 
     * @summary Search questions in a pool with pagination and filters
     * @param {number} poolId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {TestQuestionTypeDto} [questionType] Filter by question type
     * @param {string} [section] Filter by section name (partial match)
     * @param {string} [search] Full-text search across question content, answers, section, and explanation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApiInterface
     */
    searchQuestionsByPool(poolId: number, page?: number, pageSize?: number, questionType?: TestQuestionTypeDto, section?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestQuestionSearchResultDto>;

    /**
     * Returns paginated list of questions from all pools attached to the specified stage. Supports full-text search (PostgreSQL tsvector) across question content, answers, section, and explanation. 
     * @summary Search questions across all pools attached to a stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {TestQuestionTypeDto} [questionType] Filter by question type
     * @param {string} [section] Filter by section name (partial match)
     * @param {string} [search] Full-text search across question content, answers, section, and explanation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApiInterface
     */
    searchQuestionsByStage(certificationId: number, stageId: number, page?: number, pageSize?: number, questionType?: TestQuestionTypeDto, section?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestQuestionSearchResultDto>;

    /**
     * Toggles whether the pool is \"active\". Inactive pools are excluded from question drawing for newly generated exams; questions already drawn into existing exams remain intact. 
     * @summary Set test question pool active flag
     * @param {number} poolId 
     * @param {SetQuestionPoolActiveRequestDto} setQuestionPoolActiveRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApiInterface
     */
    setTestQuestionPoolActive(poolId: number, setQuestionPoolActiveRequestDto: SetQuestionPoolActiveRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Creates a new question pool and uploads questions from the Excel file. If stageId is provided, the pool is automatically attached to the stage. stageType determines the Excel format: TEST (11 columns with answers A-D) or EXAM (3 columns: nr, question, answerKey). 
     * @summary Upload new question pool from Excel file
     * @param {File} file Excel file (.xlsx) with questions
     * @param {number} [stageId] Optional stage ID to attach the pool to
     * @param {UploadNewQuestionPoolStageTypeEnum} [stageType] Stage type for the pool (TEST or EXAM). Defaults to TEST.
     * @param {string} [name] Pool name (defaults to sheet name if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApiInterface
     */
    uploadNewQuestionPool(file: File, stageId?: number, stageType?: UploadNewQuestionPoolStageTypeEnum, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionPoolUploadResultDto>;

    /**
     * Adds questions from the Excel file to an existing pool. Questions are appended, not replaced. 
     * @summary Upload questions to an existing pool (append)
     * @param {number} poolId 
     * @param {File} file Excel file (.xlsx) with questions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApiInterface
     */
    uploadToExistingPool(poolId: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<QuestionPoolUploadResultDto>;

}

/**
 * TestQuestionPoolApi - object-oriented interface
 * @export
 * @class TestQuestionPoolApi
 * @extends {BaseAPI}
 */
export class TestQuestionPoolApi extends BaseAPI implements TestQuestionPoolApiInterface {
    /**
     * 
     * @summary Attach a question pool to a TEST stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} poolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApi
     */
    public attachPoolToStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig) {
        return TestQuestionPoolApiFp(this.configuration).attachPoolToStage(certificationId, stageId, poolId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the association between the pool and stage. Does not delete the pool or its questions. Returns 409 Conflict if the TEST stage has at least one active term (status NEW or IN_PROGRESS) — detaching the pool while terms are running would break test execution for participants. 
     * @summary Detach a question pool from a TEST stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} poolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApi
     */
    public detachPoolFromStage(certificationId: number, stageId: number, poolId: number, options?: RawAxiosRequestConfig) {
        return TestQuestionPoolApiFp(this.configuration).detachPoolFromStage(certificationId, stageId, poolId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns distinct section names from all question pools attached to the given stage. Use this to populate section options when configuring the test stage. 
     * @summary Get available sections for a stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApi
     */
    public getAvailableSectionsForStage(certificationId: number, stageId: number, options?: RawAxiosRequestConfig) {
        return TestQuestionPoolApiFp(this.configuration).getAvailableSectionsForStage(certificationId, stageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get question pool detail with all questions
     * @param {number} poolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApi
     */
    public getQuestionPoolDetail(poolId: number, options?: RawAxiosRequestConfig) {
        return TestQuestionPoolApiFp(this.configuration).getQuestionPoolDetail(poolId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get question pools attached to a stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApi
     */
    public getStageQuestionPools(certificationId: number, stageId: number, options?: RawAxiosRequestConfig) {
        return TestQuestionPoolApiFp(this.configuration).getStageQuestionPools(certificationId, stageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of all question pools. Supports name search and sorting by name or creation date. 
     * @summary List all question pools with pagination and filters
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by pool name (partial match)
     * @param {ListQuestionPoolsSortByEnum} [sortBy] Field to sort by
     * @param {ListQuestionPoolsSortDirectionEnum} [sortDirection] Sort direction
     * @param {ListQuestionPoolsStageTypeEnum} [stageType] Filter by stage type (TEST or EXAM)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApi
     */
    public listQuestionPools(page?: number, pageSize?: number, search?: string, sortBy?: ListQuestionPoolsSortByEnum, sortDirection?: ListQuestionPoolsSortDirectionEnum, stageType?: ListQuestionPoolsStageTypeEnum, options?: RawAxiosRequestConfig) {
        return TestQuestionPoolApiFp(this.configuration).listQuestionPools(page, pageSize, search, sortBy, sortDirection, stageType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of questions from the specified pool. Supports full-text search (PostgreSQL tsvector) across question content, answers, section, and explanation. 
     * @summary Search questions in a pool with pagination and filters
     * @param {number} poolId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {TestQuestionTypeDto} [questionType] Filter by question type
     * @param {string} [section] Filter by section name (partial match)
     * @param {string} [search] Full-text search across question content, answers, section, and explanation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApi
     */
    public searchQuestionsByPool(poolId: number, page?: number, pageSize?: number, questionType?: TestQuestionTypeDto, section?: string, search?: string, options?: RawAxiosRequestConfig) {
        return TestQuestionPoolApiFp(this.configuration).searchQuestionsByPool(poolId, page, pageSize, questionType, section, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of questions from all pools attached to the specified stage. Supports full-text search (PostgreSQL tsvector) across question content, answers, section, and explanation. 
     * @summary Search questions across all pools attached to a stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {TestQuestionTypeDto} [questionType] Filter by question type
     * @param {string} [section] Filter by section name (partial match)
     * @param {string} [search] Full-text search across question content, answers, section, and explanation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApi
     */
    public searchQuestionsByStage(certificationId: number, stageId: number, page?: number, pageSize?: number, questionType?: TestQuestionTypeDto, section?: string, search?: string, options?: RawAxiosRequestConfig) {
        return TestQuestionPoolApiFp(this.configuration).searchQuestionsByStage(certificationId, stageId, page, pageSize, questionType, section, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggles whether the pool is \"active\". Inactive pools are excluded from question drawing for newly generated exams; questions already drawn into existing exams remain intact. 
     * @summary Set test question pool active flag
     * @param {number} poolId 
     * @param {SetQuestionPoolActiveRequestDto} setQuestionPoolActiveRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApi
     */
    public setTestQuestionPoolActive(poolId: number, setQuestionPoolActiveRequestDto: SetQuestionPoolActiveRequestDto, options?: RawAxiosRequestConfig) {
        return TestQuestionPoolApiFp(this.configuration).setTestQuestionPoolActive(poolId, setQuestionPoolActiveRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new question pool and uploads questions from the Excel file. If stageId is provided, the pool is automatically attached to the stage. stageType determines the Excel format: TEST (11 columns with answers A-D) or EXAM (3 columns: nr, question, answerKey). 
     * @summary Upload new question pool from Excel file
     * @param {File} file Excel file (.xlsx) with questions
     * @param {number} [stageId] Optional stage ID to attach the pool to
     * @param {UploadNewQuestionPoolStageTypeEnum} [stageType] Stage type for the pool (TEST or EXAM). Defaults to TEST.
     * @param {string} [name] Pool name (defaults to sheet name if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApi
     */
    public uploadNewQuestionPool(file: File, stageId?: number, stageType?: UploadNewQuestionPoolStageTypeEnum, name?: string, options?: RawAxiosRequestConfig) {
        return TestQuestionPoolApiFp(this.configuration).uploadNewQuestionPool(file, stageId, stageType, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds questions from the Excel file to an existing pool. Questions are appended, not replaced. 
     * @summary Upload questions to an existing pool (append)
     * @param {number} poolId 
     * @param {File} file Excel file (.xlsx) with questions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestQuestionPoolApi
     */
    public uploadToExistingPool(poolId: number, file: File, options?: RawAxiosRequestConfig) {
        return TestQuestionPoolApiFp(this.configuration).uploadToExistingPool(poolId, file, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListQuestionPoolsSortByEnum = {
    Name: 'name',
    CreatedAt: 'createdAt'
} as const;
export type ListQuestionPoolsSortByEnum = typeof ListQuestionPoolsSortByEnum[keyof typeof ListQuestionPoolsSortByEnum];
/**
 * @export
 */
export const ListQuestionPoolsSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type ListQuestionPoolsSortDirectionEnum = typeof ListQuestionPoolsSortDirectionEnum[keyof typeof ListQuestionPoolsSortDirectionEnum];
/**
 * @export
 */
export const ListQuestionPoolsStageTypeEnum = {
    Test: 'TEST',
    Exam: 'EXAM'
} as const;
export type ListQuestionPoolsStageTypeEnum = typeof ListQuestionPoolsStageTypeEnum[keyof typeof ListQuestionPoolsStageTypeEnum];
/**
 * @export
 */
export const UploadNewQuestionPoolStageTypeEnum = {
    Test: 'TEST',
    Exam: 'EXAM'
} as const;
export type UploadNewQuestionPoolStageTypeEnum = typeof UploadNewQuestionPoolStageTypeEnum[keyof typeof UploadNewQuestionPoolStageTypeEnum];
